import { TitleEntity, VersionGroupedByParent } from '@/redux/slices/slice_types';
import { TitleEntityV2 } from '@/redux/slices/titleV2Slice.types';

type TitleType = TitleEntity | TitleEntityV2;
export type VersionHierarchyInput = VersionGroupedByParent | TitleEntity | TitleEntityV2;

export const getFirstKeyFromVersionGroup = (versions: VersionGroupedByParent) => {
  return Object.keys(versions)[0];
};

export const getAllVersions = (nestedHierarchy: VersionHierarchyInput) => {
  const versions: Map<number, TitleType> = new Map();
  
  const traverse = (obj: any) => {
    if (obj && typeof obj === 'object') {
      // If this object has an 'id' property, it's a version
      if (obj.id !== undefined) {
        versions.set(obj.id, obj);
      } else {
        // Recursively traverse all nested objects
        Object.values(obj).forEach(value => {
          if (value && typeof value === 'object') {
            traverse(value);
          }
        });
      }
    }
  };
  
  traverse(nestedHierarchy);
  return versions;
};

export const getAllVersionsAsArray = (nestedHierarchy: VersionHierarchyInput) => {
  const versionsMap = getAllVersions(nestedHierarchy);
  return Array.from(versionsMap.values());
};

export const getDepthToVersion = (versions: VersionGroupedByParent, key: string, depth = 0): number => {
  if (versions[key]?.entity_type === 'version') {
    return depth;
  }
  const nextKey = getFirstKeyFromVersionGroup(versions[key]);
  if (!nextKey) {
	return depth;
  }

  return getDepthToVersion(versions[key], nextKey, depth + 1);
};

export const getVersionFromGroup = (versions: VersionGroupedByParent, key: string): TitleType | undefined => {
  if (versions[key]?.entity_type === 'version') {
    return versions[key] as TitleType;
  }
  const nextKey = getFirstKeyFromVersionGroup(versions[key]);
  if (!nextKey) {
    return undefined;
  }
  return getVersionFromGroup(versions[key], nextKey);
};